import { styled } from '@mui/material/styles';
import { Container, Box, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { LoginForm, useSnackbar } from 'standard';
import { signin } from '../../utils/Auth';
import { mainPath, isRelease } from '../../config';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 380,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

export default function LoginPage() {
  const navigate = useNavigate();
  const { setSnackbar } = useSnackbar();
  const submit = async ({ username, password, googleAuthCode }) => {
    // 发送登录请求
    const data = await signin(username, password, googleAuthCode);
    if (data) {
      if (data.success) {
        navigate(mainPath, { replace: true });
      } else {
        setSnackbar(data.message, 'error')
      }
    } else {
      setSnackbar('无法连接到服务器', 'error')
    }
  }

  return (
    <>
      <StyledRoot>
        <Container maxWidth="sm" >
          <StyledContent>
            <Box sx={{ padding: '30px', backgroundColor: 'white', boxShadow: '5px 5px 5px gray' }}>
              <LoginForm
                submit={submit}
                requireGoogleAuthCode={isRelease()}
                logo={
                  <Stack
                    sx={{
                      alignItems: "center",
                    }}
                  >
                    <Box
                      component="img"
                      src="login.png"
                      sx={{ height: 140, width: 140, cursor: 'pointer' }}
                    />
                  </Stack>
                }
              />
            </Box>
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
